var _g, _path, _g2, _path2, _g3, _path3, _g4, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrontMiddleBackExtensionBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 165,
    viewBox: "0 0 125 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4838_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 38.7998L70.5 10.7998V68.7998L15.5 96.7998L15.5 38.7998Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15.5 38.7998L70.5 10.7998V68.7998L15.5 96.7998L15.5 38.7998Z",
    fill: "#EC691A"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4838_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2 59.5L90.2 31.5V92.5L35.2 120.5L35.2 59.5Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M35.2 59.5L90.2 31.5V92.5L35.2 120.5L35.2 59.5Z",
    fill: "#EC691A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4838_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5 83.5L109.5 55.5V116.5L54.5 144.5L54.5 83.5Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M54.5 83.5L109.5 55.5V116.5L54.5 144.5L54.5 83.5Z",
    fill: "#EC691A"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4838_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.5 144.5L109.5 116.5V113.5L54.5 141.5V144.5Z",
    fill: "#EC691A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0223 148.639C61.2176 148.834 61.5341 148.834 61.7294 148.639L64.9114 145.457C65.1067 145.262 65.1067 144.945 64.9114 144.75C64.7161 144.555 64.3995 144.555 64.2043 144.75L61.3759 147.578L58.5474 144.75C58.3522 144.555 58.0356 144.555 57.8403 144.75C57.6451 144.945 57.6451 145.262 57.8403 145.457L61.0223 148.639ZM61.3759 137.758H60.8759V148.285H61.3759H61.8759V137.758H61.3759Z",
    fill: "#EC691A"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.3867,
    y1: 141.288,
    x2: 109.948,
    y2: 113.036,
    stroke: "#EC691A",
    strokeWidth: 0.5
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3885 105.385L15.5 115.897L35.3885 137.618L54.4766 140.098M86.9674 127.807C85.7567 135.618 85.6107 136.19 84.4 144L61.8427 141.036",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M54.46 140.103L61.8679 141.036",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2 144C84.2 137.869 84.3315 135.611 84.3315 129.48M15.5 115.897V38.8512M35.3885 137.618V61.5M90.0001 33L84.3759 67.8019L35.3885 61.5M90.0001 33L70.4696 11M90.0001 33L109.5 55M90.0001 33V65.6997M35.3885 61.5L15.5 38.8512M35.3885 61.5L54.5001 83.5M70.4696 11L15.5 38.8512M70.4696 11L70.5 43.0542",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M70.5 43V88",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M90 65.5V107",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M84.3007 67.9004C84.3007 67.9004 84.3313 106.517 84.3313 129.48",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M86.9674 127.807C88.002 120.672 88.9654 114.089 90 106.954L70.4695 88L35.2291 105.486",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4838_4816",
    x: 0.5,
    y: 0.799805,
    width: 85,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4838_4816"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4838_4816",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4838_4816",
    x: 20.2,
    y: 21.5,
    width: 85,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4838_4816"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4838_4816",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4838_4816",
    x: 39.5,
    y: 45.5,
    width: 85,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4838_4816"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4838_4816",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4838_4816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 57,
    fill: "white",
    transform: "translate(54.5 92.2998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontMiddleBackExtensionBack);
export default __webpack_public_path__ + "static/media/FrontMiddleBackExtensionBack.e678915d4493cacd89dd599d3e939152.svg";
export { ForwardRef as ReactComponent };